import { ISLPGoalsAndAssessmentRequestPayload } from "utils/interfaces/slp";
import baseService from "services/base-service";
import { IUpdateContactDateRequestPayloadValues } from "./types";

const studentProfileDetailsBaseUrl = `/api/SLP`;

const getNextOrCurrentSLP = async (payload: { id: number }) =>
  baseService.get(
    `${studentProfileDetailsBaseUrl}/NextOrCurrentSLP?id=${payload.id}`
  );

const deferSLP = async (payload: { dueDate: string; slpId: number }) =>
  baseService.put(`${studentProfileDetailsBaseUrl}/DeferSLP`, payload);

const allocatePLA = async (payload: {
  dueDate: string;
  plaId: number;
  slpId: number;
}) => baseService.put(`${studentProfileDetailsBaseUrl}/AllocatePLA`, payload);

const getContactNote = async (payload: { sLPId: number }) =>
  baseService.get(
    `${studentProfileDetailsBaseUrl}/GetContactNote?sLPId=${payload.sLPId}`
  );

const getAuditTrailList = async (payload: { studentId: number }) =>
  baseService.get(
    `${studentProfileDetailsBaseUrl}/GetSLPAuditTrail?studentId=${payload.studentId}`
  );

const deleteCompletedSLP = async (payload: { id: number }) =>
  baseService.delete(
    `${studentProfileDetailsBaseUrl}/DeleteCompletedSLP?id=${payload.id}`
  );

const getCompletedSLPDetails = async (payload: { id: number }) =>
  baseService.get(
    `${studentProfileDetailsBaseUrl}/CompletedSLPDetails?id=${payload.id}`
  );

const getAllSLPGoalsAndAssessment = async (
  payload: ISLPGoalsAndAssessmentRequestPayload
) =>
  baseService.post(
    `${studentProfileDetailsBaseUrl}/GetAllSLPGoalsAndAssessment`,
    payload
  );

const updateContactDate = async (
  payload: IUpdateContactDateRequestPayloadValues
) =>
  baseService.put(`${studentProfileDetailsBaseUrl}/UpdateContactDate`, payload);

export default {
  getNextOrCurrentSLP,
  deferSLP,
  allocatePLA,
  getContactNote,
  getAuditTrailList,
  deleteCompletedSLP,
  getCompletedSLPDetails,
  getAllSLPGoalsAndAssessment,
  updateContactDate,
};
